export default __webpack_public_path__ + "static/media/alex.d0c5b30a.png";